import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Image from 'src/components/atomic/atom/Image'
import main_logo from 'src/assets/imgs/logo/main_logo.png'
import Span from 'src/components/atomic/atom/Span'
import { LeftLayoutWrap, RightLayoutWrap } from 'src/layout/Layout'
import { ContentsWrap } from 'src/layout/ContentsWrap'
import Lottie from 'lottie-react'
import MainbgLottie from 'src/assets/imgs/lottie/mfinder-global-main-bg.json'
import useMatchHook from 'src/hooks/useMatch.hook'
import { useTranslation } from 'react-i18next'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { setLoginStatus } from 'src/store/Reducer/common/commonSlice'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'

const AccountTemplate = () => {
  const { currentMedia, setMediaStyle } = useMediaQueryHook()
  const dispatch = useAppDispatch()
  const { m_login } = useMatchHook()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { updateStorageData } = SessionStorageUtils()
  const { t } = useTranslation()

  const developLoginHandler = () => {
    dispatch(setLoginStatus(true))
    updateStorageData('userInfo', {
      Email: 'test',
      VerifyPin: 'test',
      pinHash: 'test',
    })
    navigate('/home')
  }

  return (
    <>
      <LeftLayoutWrap media={currentMedia} $path={pathname}>
        <ContentsWrap media={currentMedia}>
          <Image
            $ImgSrc={main_logo}
            width={'144px'}
            height={'108px'}
            $margin={setMediaStyle('196px auto 0 auto', '250px auto  0 auto', '82px auto 0 auto')}
            onClick={() => window.location.replace(window.location.origin)}
          />
          <Span
            option={setMediaStyle('huge_bold', 'mediumLarge_bold', 'mediumLarge_bold')}
            $margin={setMediaStyle(
              '142px auto 44px auto',
              '94px auto 52px auto',
              '35px auto 52px auto',
            )}
            className={!m_login ? 'pin_reset_click' : ''}
          >
            {m_login
              ? t('LOGIN.TITLE', { defaultValue: 'Sign in to Locate Lost Device' })
              : t('RESET_PIN.TITLE', { defaultValue: 'Reset PIN' })}
          </Span>
          <Outlet />
          {window.location.href.includes('5.0') && (
            <button
              onClick={developLoginHandler}
              style={{
                borderRadius: '10px',
                marginTop: '20px',
                width: '100%',
                background: 'red',
                color: 'white',
                border: 'none',
                height: '40px',
              }}
            >
              UI 수정용 / offline login
            </button>
          )}
        </ContentsWrap>
      </LeftLayoutWrap>
      <RightLayoutWrap media={`${currentMedia}`} $path={pathname}>
        <Lottie animationData={MainbgLottie} style={{ margin: '0 auto' }} />
      </RightLayoutWrap>
    </>
  )
}
export default AccountTemplate
